import { useEffect, useState } from 'react';
import { getApiBase } from '../apiBase';

const API_BASE = getApiBase();

export default function ListRooms() {
    const [rooms, setRooms] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const load = async () => {
            try {
                const res = await fetch(`${API_BASE}/rooms`, { cache: 'no-store' });
                if (!res.ok) {
                    console.error('Erro ao buscar /rooms, status:', res.status);
                    setRooms([]);
                    return;
                }
                const data = await res.json();
                setRooms(data.rooms || []);
            } catch (e) {
                console.error('Erro ao buscar /rooms', e);
                setRooms([]);
            } finally {
                setLoading(false);
            }
        };
        load();
    }, []);

    if (loading) return <div className="card-box"><h3>Carregando salas…</h3></div>;

    return (
        <div className="card-box">
            <h2 className="text-gray-900 mb-4">Salas criadas</h2>
            {rooms.length === 0 && <p className="text-gray-700">Nenhuma sala ativa.</p>}
            {rooms.length > 0 && (
                <ul className="list-none p-0 m-0 mx-auto max-w-2xl space-y-3">
                    {rooms.map((r) => (
                        <li
                            key={r.roomId}
                            className="p-4 rounded-lg bg-white border border-gray-200 shadow-sm flex flex-wrap items-center justify-between gap-3"
                        >
                            <div className="text-gray-800 text-[15px] leading-relaxed">
                                <div><strong>ID:</strong> {r.roomId}</div>
                                <div className="min-w-0"><strong>Dono:</strong> <span className="truncate inline-block max-w-full align-bottom" title={r.roomName}>{r.roomName}</span></div>
                                <div><strong>Participantes:</strong> {r.totalUsers}</div>
                                {r.stories?.length > 0 && (
                                    <div><strong>Histórias:</strong> {r.stories.length}</div>
                                )}
                            </div>
                            <div className="flex gap-2 flex-shrink-0">
                                <a className="button" href={`/room/${r.roomId}`}>Entrar</a>
                                <button
                                    className="button"
                                    onClick={() => {
                                        navigator.clipboard.writeText(`${window.location.origin}/room/${r.roomId}`);
                                    }}
                                >
                                    Copiar Link
                                </button>
                            </div>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}
